export const STRIPE_ERROR_CODES = {
  CARD_DECLINED: 'card_declined',
  INCOMPLETE_CVC: 'incomplete_cvc',
  INCOMPLETE_EXPIRY: 'incomplete_expiry',
  INCOMPLETE_NUMBER: 'incomplete_number',
  INVALID_EXPIRY_YEAR_PAST: 'invalid_expiry_year_past',
  INVALID_NUMBER: 'invalid_number',
  TESTMODE_CHARGES_ONLY: 'testmode_charges_only'
};
